import React, { memo } from 'react'
import dynamic from 'next/dynamic'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import GoogleRating from 'components/shared/GoogleRating'
import UserGoogleReviews from 'components/shared/UserGoogleReviews'
import { addIdProp, addTestIdProp } from 'utils/universal'
import sx from './styles'

const PressDynamic = dynamic(() => import('components/shared/Press'))

const mediaItemsV2 = [
  {
    image: {
      src: '/img/sell-your-car/press/AIMGroup.png',
      alt: 'AIM Group',
      url: 'https://aimgroup.com/2021/08/09/clikauto-launches-in-four-mexican-regions/',
      width: 96,
      height: 24,
    },
  },
  {
    image: {
      src: '/img/sell-your-car/press/MarketsInsider.png',
      alt: 'Markets Insider',
      url: 'https://markets.businessinsider.com/news/stocks/clikauto-democratizes-safe-and-transparent-used-car-buying-in-mexico-1030690581',
      width: 62,
      height: 20,
    },
  },
  {
    image: {
      src: '/img/sell-your-car/press/Elsoldemexico.png',
      alt: 'El sol de mexico',
      url: 'https://www.elsoldemexico.com.mx/deportes/automotriz/clikauto-democratiza-la-compra-venta-segura-de-autos-usados-en-mexico-7065940.html',
      width: 96,
      height: 24,
    },
  },
  {
    image: {
      src: '/img/sell-your-car/press/Yahoo!.png',
      alt: 'yahoo!',
      // url: 'https://www.mural.com.mx/libre/online07/aplicacionEI/webview/compartir/ImagenEdImpresa.aspx?Titulo=Automotriz&Resumen=13%20de%20mayo&img=https://hemerotecalibre.mural.com.mx/20230513/large/MAUT20230513-002.JPG&md5=b7474362a311d8f77b5b2f9394d762cb',
      width: 72,
      height: 36,
    },
  },
  {
    image: {
      src: '/img/sell-your-car/press/Milenio.png',
      alt: 'Milenio',
      url: 'https://www.milenio.com/negocios/clikauto-busca-aprovechar-auge-autos-usados-mexico',
      width: 98,
      height: 16,
    },
  },
  {
    image: {
      src: '/img/sell-your-car/press/Reforma.png',
      alt: 'Reforma',
      url: 'https://www.reforma.com/libre/online07/aplicacionEI/webview/compartir/ImagenEdImpresa.aspx?Titulo=Automotriz&Resumen=13%20de%20mayo&img=https://hemerotecalibre.reforma.com/20230513/large/RAUT20230513-002.JPG&md5=0af78bf955f9ddb3bbdc7f7040c1f2b3',
      width: 96,
      height: 14,
    },
  },
  {
    image: {
      src: '/img/sell-your-car/press/alianza-automotriz.png',
      alt: 'alianza automotriz',
      // url: 'https://www.mural.com.mx/libre/online07/aplicacionEI/webview/compartir/ImagenEdImpresa.aspx?Titulo=Automotriz&Resumen=13%20de%20mayo&img=https://hemerotecalibre.mural.com.mx/20230513/large/MAUT20230513-002.JPG&md5=b7474362a311d8f77b5b2f9394d762cb',
      width: 56,
      height: 29,
    },
  },
]

const GoogleReviewsAndPress = (props) => {
  const {
    variant = 'column',
    title = 'REVIEWS_TITLE',
    description,
    buttonLabel = 'SEE_ALL_REVIEWS',
    sx: sxProps = {},
    showPress = true,
    testId: testIdProp,
  } = props

  const { formatMessage: f } = useIntl()

  const containerStyles = {
    ...sx.root,
    ...sxProps,
  }

  return (
    <Box
      sx={containerStyles}
      {...addTestIdProp(testIdProp)}
      {...addIdProp(testIdProp)}
    >
      <Container>
        <Grid
          container
          sx={sx.container}
        >
          <Grid
            size={{
              xs: 12,
              lg: variant === 'column' ? 12 : 4,
            }}
            container
            sx={sx.paddingItem}
          >
            <GoogleRating
              title={title}
              description={description}
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              lg: variant === 'column' ? 12 : (!showPress ? 8 : 4),
            }}
            sx={sx.paddingItem}
          >
            <UserGoogleReviews />
          </Grid>

          {showPress && (
            <Grid
              size={{
                xs: 12,
                lg: variant === 'column' ? 12 : 4,
              }}
              sx={sx.paddingItem}
            >
              <PressDynamic mediaItems={mediaItemsV2} />
            </Grid>
          )}

          {variant === 'column' && (
            <>
              <Grid
                size={12}
                mt={2}
                alignContent="center"
              >
                <Link
                  href="https://www.google.com/maps/place/ClikAuto/@19.5278095,-99.2263778,17z/data=!4m7!3m6!1s0x85d203864bbbc373:0x2a8c27827014eaec!8m2!3d19.5278045!4d-99.2241891!9m1!1b1"
                  target="_blank"
                  rel="noopener"
                  sx={sx.link}
                >
                  <Button
                    sx={sx.button}
                    fullWidth
                    aria-label={f({ id: buttonLabel })}
                  >
                    <FormattedMessage
                      id={buttonLabel}
                    />
                  </Button>
                </Link>
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </Box>
  )
}

export default memo(GoogleReviewsAndPress)
